module.exports = __webpack_public_path__ + "img/12.e40d81f1.jpg";